<script setup>
  const props = defineProps({
    padding: {
      type: Boolean,
      default: true
    }
  })
</script>

<template>
  <div :class="['jwx-page-block', 'jwx-data-container', {'jwx-page-block--padding-off': !props.padding}]">
    <slot></slot>
  </div>
</template>